import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import './CustomControls.css';
import * as Constants from "../../constants"
import {ReactComponent as SearchIcon} from '../../assets/img/controls/icons/search.svg';
import {ReactComponent as SearchSelectedIcon} from '../../assets/img/controls/icons/search-selected.svg';
import {ReactComponent as SeveralWarningIcon} from '../../assets/img/controls/icons/several-warning.svg';
import {ReactComponent as SeveralWarningSelectedIcon} from '../../assets/img/controls/icons/several-warning-selected.svg';
import {ReactComponent as WarningIcon} from '../../assets/img/controls/icons/warning.svg';
import {ReactComponent as WarningSelectedIcon} from '../../assets/img/controls/icons/warning-selected.svg';
import {ReactComponent as TemperatureIcon} from '../../assets/img/controls/icons/temperature.svg';
import {ReactComponent as TemperatureSelectedIcon} from '../../assets/img/controls/icons/temperature-selected.svg';
import {ReactComponent as WindIcon} from '../../assets/img/controls/icons/wind.svg';
import {ReactComponent as WindSelectedIcon} from '../../assets/img/controls/icons/wind-selected.svg';
import {ReactComponent as ChaserIcon} from '../../assets/img/controls/icons/chaser.svg';
import {ReactComponent as ChaserSelectedIcon} from '../../assets/img/controls/icons/chaser-selected.svg';
import {ReactComponent as StormReportsIcon} from '../../assets/img/controls/icons/storm-reports.svg';
import {ReactComponent as StormReportsSelectedIcon} from '../../assets/img/controls/icons/storm-reports-selected.svg';
import {ReactComponent as StormTracksIcon} from '../../assets/img/controls/icons/storm-tracks.svg';
import {ReactComponent as StormTracksSelectedIcon} from '../../assets/img/controls/icons/storm-tracks-selected.svg';
import {ReactComponent as StormTracksAndTornadoesIcon} from '../../assets/img/controls/icons/storm-tracks-and-tornadoes.svg';
import {ReactComponent as StormTracksAndTornadoesSelectedIcon} from '../../assets/img/controls/icons/storm-tracks-and-tornadoes-selected.svg';
import {ReactComponent as LightningIcon} from '../../assets/img/controls/icons/lightning.svg';
import {ReactComponent as LightningSelectedIcon} from '../../assets/img/controls/icons/lightning-selected.svg';
import {ReactComponent as PlayIcon} from '../../assets/img/controls/icons/play.svg';
import {ReactComponent as PlaySelectedIcon} from '../../assets/img/controls/icons/play-selected.svg';
import {ReactComponent as InfoIcon} from '../../assets/img/controls/icons/info.svg';
import {ReactComponent as InfoSelectedIcon} from '../../assets/img/controls/icons/info-selected.svg';
import {ReactComponent as OpacityIcon} from '../../assets/img/controls/icons/opacity.svg';
import {ReactComponent as OpacitySelectedIcon} from '../../assets/img/controls/icons/opacity-selected.svg';
import {ReactComponent as FullScreenInIcon} from '../../assets/img/controls/icons/fullscreen.svg';
import {ReactComponent as FullScreenSelectedInIcon} from '../../assets/img/controls/icons/fullscreen-selected.svg';
import {ReactComponent as CustomPinIcon} from '../../assets/img/controls/icons/custom-pin.svg';
import {ReactComponent as CustomPinSelectedIcon} from '../../assets/img/controls/icons/custom-pin-selected.svg';
import SearchPanel from '../search/Search';
import { useMap, useMapEvents } from "react-leaflet";
import { Warnings } from '../warnings/Warnings';
import { Temperatures } from '../temperatures/Temperatures';
import { Winds } from '../winds/Winds';
import { useTemperaturesWinds } from '../../services/temperaturesWinds/temperaturesWinds';
import { StormReports } from '../stormReports/StormReports';
import { StormTracks } from '../stormTracks/StormTracks';
import { Lightning } from '../lightning/Lightning';
import { NationalRadarService } from '../../services/nationalRadar/NationalRadar';
import { StormChaser } from '../stormChaser/stormChaser';
import loadingContext from '../../context/loadingContext';
import parameterContext from '../../context/parameterContext';
import opacitySliderContext from '../../context/opacitySliderContext';
import { NationalAnimation } from '../nationalAnimation/NationalAnimation';
import { useSearchParams } from "react-router-dom";
import { PlacesType } from 'react-tooltip'
import L, { tooltip } from 'leaflet';
import { MapLegend } from '../mapLegend/MapLegend';
import { ConstructionPins } from '../constructionPins/ConstructionPins';
import { OpacityService } from '../opacitySlider/OpacityService';
import { TooltipControls } from '../tooltipControls/TooltipControls';
import { CustomPin } from '../customPin/CustomPin';
import { FullScreen } from '../fullScreen/FullScreen';
import { useTimestampContext } from '../../context/timestampContext';
import Tornado from '../tornado/Tornado';
import { isValidSelectedControls } from '../../utils/helpers';

interface LegendIcon {
    component: any;
    componentSelected: any;
    name: string;
    tabIndex?: number;
    tooltip: {
        content: string;
        altContent?: string;
        direction: PlacesType;
        ariaLabel?: string;
    }
}

const legendIcons : LegendIcon[] = [
    {component: SearchIcon, tabIndex:3, componentSelected: SearchSelectedIcon, name: 'search', tooltip: {content: 'Search', direction: 'right', ariaLabel: 'Search panel'}},
    {component: CustomPinIcon, tabIndex:4, componentSelected: CustomPinSelectedIcon, name: 'custom-pin', tooltip:{content: 'Press to place a custom pin',altContent:'Click on the map to place the pin', direction: 'right', ariaLabel: 'Custom pin placement mode'}},
    {component: SeveralWarningIcon, tabIndex:5, componentSelected: SeveralWarningSelectedIcon, name: 'several-warning', tooltip: {content:'Severe Warnings', direction: 'right', ariaLabel: 'Severe warnings'}},
    {component: WarningIcon, tabIndex:6, componentSelected: WarningSelectedIcon, name: 'warning', tooltip: {content:'Other Alerts', direction: 'right', ariaLabel: 'Other alerts'}},
    {component: TemperatureIcon, tabIndex:7, componentSelected: TemperatureSelectedIcon, name: 'temperature', tooltip: {content:'Temperature', direction: 'right', ariaLabel: 'Temperature'}},
    {component: WindIcon,  tabIndex:8, componentSelected: WindSelectedIcon, name: 'wind', tooltip: {content:'Wind Direction', direction: 'right', ariaLabel: 'Wind direction'}},
    {component: ChaserIcon, tabIndex:9, componentSelected: ChaserSelectedIcon, name: 'chaser', tooltip: {content:'Display Chasers and Live Video', direction: 'right', ariaLabel: 'Storm chasers'}},
    {component: StormReportsIcon, tabIndex:10, componentSelected: StormReportsSelectedIcon, name: 'storm-report', tooltip:{content: 'Storm Reports', direction: 'right', ariaLabel: 'Storm reports'}},
    {component: StormTracksIcon, tabIndex:11, componentSelected: StormTracksSelectedIcon, name: 'storm-track', tooltip:{content: 'Storm Tracks', direction: 'right', ariaLabel: 'Storm tracks'}},
    {component: StormTracksAndTornadoesIcon, tabIndex:11, componentSelected: StormTracksAndTornadoesSelectedIcon, name: 'storm-track-and-tornadoes', tooltip:{content: 'Storm/Tornado Tracks', direction: 'right', ariaLabel: 'Storm/Tornado Tracks'}},
    {component: LightningIcon, tabIndex:12, componentSelected: LightningSelectedIcon, name: 'lightning', tooltip:{content: 'Lightning: 20 Second updates', direction: 'right', ariaLabel: 'Lightning'}},
    {component: FullScreenInIcon, tabIndex:13, componentSelected: FullScreenSelectedInIcon, name: 'fullscreen', tooltip:{content: 'Fullscreen', direction: 'right', ariaLabel: 'Fullscreen'}},
    {component: PlayIcon, tabIndex:14, componentSelected: PlaySelectedIcon, name: 'play', tooltip:{content: 'National Radar Animation', direction: 'right', ariaLabel: 'National radar animation'}},
    {component: InfoIcon, tabIndex:15, componentSelected: InfoSelectedIcon, name: 'info', tooltip:{content: 'Info Legend', direction: 'right', ariaLabel: 'Info legend'}},
    {component: OpacityIcon, tabIndex:16, componentSelected: OpacitySelectedIcon, name: 'opacity', tooltip:{content: 'Opacity', direction: 'right', ariaLabel: 'Opacity slider'}},
];

export const CustomControls= () => {
    const setLoading = useContext(loadingContext);
    const {setTimestamp} = useTimestampContext();
    const parameters = useContext(parameterContext);
    const {opacity} = useContext(opacitySliderContext);
    const [selected, setSelected] = useState<string[]>([]);
    const [isPlayingNationalRadar, setIsPlayingNationalRadar] = useState<boolean>(false);
    const temperaturesWinds = useTemperaturesWinds();
    const [serviceNationalRadar, setServiceNationalRadar] = useState<NationalRadarService | null>(null);
    const autoloadNationalRadar = parameters?.autoloop_enabled ?? false;
    const map = useMap();
    const [searchParams, setSearchParams] = useSearchParams();
    const minDbz = searchParams.get("mindbz") || "0";
    const [dbz, setDbz] = useState(minDbz);
    const searchButtonRef = useRef<HTMLButtonElement>(null);
    const opacityButtonRef = useRef<HTMLButtonElement>(null);

    const inputRef = useRef<HTMLInputElement>(null);
    let showConstructionPins = false;
    const constructionPins=searchParams.get('constructionPins')
    const key=searchParams.get('key')
    if (constructionPins && constructionPins == '1'){
        showConstructionPins = true;
    }

    const handleIconClick = (iconName: string) => {
        const selections = getSelections(iconName);
        setSelected(selections);
        if (iconName === 'search') {
            // Close opacity slider in case it is open
            setSelected(prev => prev.filter(item => item !== 'opacity'));
            // Giving timeout for the search panel to render
            setTimeout(() => {
                const searchInput = document.querySelector('.search-input') as HTMLInputElement;
                if (searchInput) {
                    searchInput.focus();
                }
            }, 100);
        }

        if (iconName === 'opacity') {
            // Close search panel in case it is open
            setSelected(prev =>  prev.filter(item => item !== 'search'));
            // Giving timeout for the opacity slider to render
            setTimeout(() => {
                const opacitySlider = document.querySelector('.rc-slider') as HTMLElement;
                if (opacitySlider) {
                    opacitySlider.focus();
                    // Add aria-label for screen readers
                    opacitySlider.setAttribute('aria-label', 'Opacity slider');
                }
            }, 100);
        }

        // Close search panel and opacity slider in case it is open when another icon is clicked
        if (!['search', 'fullscreen', 'opacity'].includes(iconName)) {
            setSelected(prev => prev.filter(item => !['search', 'opacity'].includes(item)));
        }
    };

    const handleEscapeKey = useCallback((event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            if (selected.includes('search')) {
                setSelected(prev => prev.filter(item => item !== 'search'));
                searchButtonRef.current?.focus();
            }
            if (selected.includes('opacity')) {
                setSelected(prev => prev.filter(item => item !== 'opacity'));
                opacityButtonRef.current?.focus();
            }
        }
    }, [selected, setSelected]);

    useEffect(() => {
        window.addEventListener('keydown', handleEscapeKey);
        return () => window.removeEventListener('keydown', handleEscapeKey);
    }, [handleEscapeKey]);

    const getSelections = (currentIcon: string) => {
        const prevSelected = selected;
        if (prevSelected.includes(currentIcon)) {
            return prevSelected.filter(name => name !== currentIcon);
        } else {
            return [...prevSelected, currentIcon];
        }
    }
    const setSelections = () => {
        //const selections = localStorage.getItem('selected_controls_' + key);
        //if (isValidSelectedControls(selections)) {
        //    setSelected(JSON.parse(selections));
        //} else {
            const selections = [];
            if (!parameters.turnoffWarnings) {
                selections.push('several-warning');
            }
            if (parameters.displayBulletins) {
                selections.push('warning');
            }
            if (!parameters.temperature_off) {
                selections.push('temperature');
            }
            if (!parameters.windDirection_off) {
                selections.push('wind');
            }
            if (parameters.show_storm_reports) {
                selections.push('storm-report');
            }
            if (parameters.show_storm_tracks) {
                if (parameters.subscription_plan === '50') {
                    selections.push('storm-track-and-tornadoes');
                } else {
                    selections.push('storm-track');
                }
            }
            if (autoloadNationalRadar) {
                selections.push('play');
            }
            if (parameters.auto_lightning_enable) {
                selections.push('lightning');
            }

            setSelected(selections);
        //}
    };

    useMapEvents({
        zoomstart: (event) => {
            if (serviceNationalRadar){
                serviceNationalRadar.changeDrag(true)
            }
        },
        zoomend: (event) => {
            if (serviceNationalRadar && !isPlayingNationalRadar) {
                serviceNationalRadar.changeDrag(false)
                serviceNationalRadar.refresh(false);
            }

            if (serviceNationalRadar){
                serviceNationalRadar.changeDrag(false);
                if (selected.includes('play') && !autoloadNationalRadar){
                    setIsPlayingNationalRadar(false)
                   handleIconClick('play');
                }else{
                    if (autoloadNationalRadar && !selected.includes('play')){
                        setIsPlayingNationalRadar(true)
                        handleIconClick('play');
                    }
                }
                serviceNationalRadar.pauseAnimationOnTransition();

            }

        },
        dragstart: (event) => {
            if (serviceNationalRadar){
                serviceNationalRadar.changeDrag(true)
            }

        },
        dragend: (event) => {

            if (serviceNationalRadar){
                serviceNationalRadar.changeDrag(false)

                if (selected.includes('play') && !autoloadNationalRadar){
                    setIsPlayingNationalRadar(false)
                    handleIconClick('play');

                }else{
                    if (autoloadNationalRadar && !selected.includes('play')){
                        setIsPlayingNationalRadar(true)
                        handleIconClick('play');

                    }
                }
                serviceNationalRadar.pauseAnimationOnTransition();

            }
        }
    })
    const startWithAnimation = ():boolean =>{
        const selections = localStorage.getItem('selected_controls_'+key);
        if (isValidSelectedControls(selections)) {
            const selectionsArray = JSON.parse(selections);
            return selectionsArray.includes('play');
        }

        return autoloadNationalRadar ?? false;
    }


    const initNationalRadar = async () => {
        setLoading(true);
        const useLargeFeed = parameters.useLargeFeed ?? false;
        const autoRefresh = parameters.autorefresh_enabled ?? false;
        const useAllFrames = parameters.useAllFrames ?? false;
        const skipFrames = parameters.skipSomeFrames ?? false;
        const animate = startWithAnimation();
        if (animate){
            setIsPlayingNationalRadar(true);
        }
        const serviceNationalRadar = new NationalRadarService(map, useLargeFeed, autoRefresh, useAllFrames, skipFrames, animate, autoloadNationalRadar,timestamp=> setTimestamp(timestamp));
        await serviceNationalRadar.init(parseInt(dbz), opacity.value);
        setServiceNationalRadar(serviceNationalRadar);
        setLoading(false);
        setTimestamp(serviceNationalRadar.imageNames[0]);

    }

    const initTemperaturesWinds = async () => {
        if (temperaturesWinds){
            setLoading(true);
            await temperaturesWinds.init(map);
            setLoading(false);
        }
    }

     useEffect(() => {
         window.addEventListener('loadingFinished', ()=> setLoading(false));
         window.addEventListener('loadingStart', ()=> setLoading(true));
         if (temperaturesWinds){
             initServices();
         }
         return () => {
             window.removeEventListener('loadingFinished', ()=> setLoading(false));
             window.removeEventListener('loadingStart', ()=> setLoading(false));
         };

    },[temperaturesWinds]);

    useEffect(() => {
        if (serviceNationalRadar) {
            serviceNationalRadar.setOpacity( opacity.value);
        }
    }, [ opacity.value])

    useEffect(() => {
        if (inputRef && inputRef.current) {
            L.DomEvent.disableClickPropagation(inputRef.current);
            L.DomEvent.disableScrollPropagation(inputRef.current);
        }
    });

    useEffect(() => {
        // Put on timeout so on page refresh it will not use initial state
        setTimeout(() => {
            localStorage.setItem('selected_controls_'+key, JSON.stringify(selected.filter((item: string) => item !== 'fullscreen')));
        }, 100)
    }, [selected, key]);

    useEffect(() => {
        const selections = localStorage.getItem('selected_controls_'+key);
        if (isValidSelectedControls(selections)) {
            setSelected(JSON.parse(selections));
        }
    }, [])

     const initServices = async () => {
         await initNationalRadar();
         await initTemperaturesWinds();
         setSelections();
     }

     const changeDbz = async () => {
         if (parseInt(dbz) < 0 || parseInt(dbz) > 255) {
             alert('Please enter a value between 0 and 255');
         } else {
             if (serviceNationalRadar) {
                 setLoading(true);
                 await serviceNationalRadar.changeDbz(parseInt(dbz));
                 setLoading(false);
             }
         }
     }

    return (
        <>
            <div className="custom-controls" id={'controls-map'}>
                <div className="toolbar" ref={inputRef}>
                    { !parameters.exclude_all_buttons && legendIcons.map((icon:LegendIcon, index) => {
                        const IconComponent = icon.component;
                        const IconComponentSelected = icon.componentSelected;
                        const name = icon.name;
                        if ((name ==='search' && !parameters.search_enabled) ||
                            (name ==='several-warning' && !parameters.warnings_enabled) ||
                            (name ==='warning' && !parameters.bulletins_enabled) ||
                            (name === 'temperature' && !parameters.temperature_enabled) ||
                            (name === 'wind' && !parameters.windDirection_enabled) ||
                            (name === 'storm-report' && !parameters.storm_reports_enabled) ||
                            (name === 'storm-track' && (!parameters.storm_tracks_enabled || parameters.subscription_plan === '50')) ||
                            (name === 'storm-track-and-tornadoes' && (!parameters.storm_tracks_enabled || parameters.subscription_plan !== '50')) ||
                            (name === 'chaser' && !parameters.storm_chaser_enabled) ||
                            (name === 'lightning' && !parameters.lightning) ||
                            (name === 'info' && !parameters.legend_enabled) ||
                            (name === 'fullscreen' && !parameters.fullscreen_enabled) ||
                            (name === 'custom-pin' && !parameters.defineCustomPin)
                        ){
                            return null
                        }

                        return (
                            <button
                                key={ index }
                                ref={icon.name === 'search' ? searchButtonRef :
                                    icon.name === 'opacity' ? opacityButtonRef : undefined}
                                data-tooltip-id="tooltip-custom-controls"
                                data-tooltip-content={ (icon.tooltip.altContent && selected.includes(icon.name))? icon.tooltip.altContent : icon.tooltip.content }
                                data-tooltip-content-selected={icon.name}
                                data-tooltip-place={ icon.tooltip.direction }
                                data-tooltip-class-name={ `tooltip-icon-controls tooltip-${icon.name}` }
                                className={ `icon-button ${ icon.name } ${ selected.includes(icon.name) ? 'selected' : '' }` }
                                onClick={ () => handleIconClick(icon.name) }
                                aria-pressed={selected.includes(icon.name)}
                                aria-label={icon.tooltip.ariaLabel || icon.tooltip.content}
                                tabIndex={ icon.tabIndex || 0 }
                            >
                                { selected.includes(icon.name) ? <IconComponentSelected className="icon" aria-hidden={true}/> :
                                    <IconComponent className="icon" aria-hidden={true}/> }
                            </button>
                        );
                    }) }
                </div>
            </div>
            <div className={ 'services-panel' }>
                { (selected.includes('search') && parameters.search_enabled) &&
                    <SearchPanel setSelected={setSelected}/> }
                { (selected.includes('chaser') && parameters.storm_chaser_enabled ) && <StormChaser/> }
            </div>

                { (selected.includes('several-warning') && parameters.warnings_enabled) &&
                    <Warnings type={ 'warning' } opacity={ opacity.value } /> }
                { (selected.includes('warning') && parameters.bulletins_enabled) && <Warnings type={ 'normal_warning' } opacity={ opacity.value }/> }
                { (selected.includes('temperature') && parameters.temperature_enabled) && <Temperatures/> }
                { (selected.includes('wind') && parameters.windDirection_enabled) && <Winds/> }
                { (selected.includes('storm-report') && parameters.storm_reports_enabled) && <StormReports/> }
                { (selected.includes('storm-track')  && parameters.storm_tracks_enabled) && <StormTracks/> }
                { (selected.includes('storm-track-and-tornadoes')  && parameters.storm_tracks_enabled) && (
                    <>
                        <StormTracks />
                        <Tornado />
                    </>
                ) }
                { (selected.includes('lightning') && parameters.lightning) && <Lightning/> }
                { (selected.includes('info') && parameters.legend_enabled) && <MapLegend/> }
                { selected.includes('play') && <NationalAnimation service={ serviceNationalRadar } isPlayingNationalRadar={ isPlayingNationalRadar }
                                                                  setIsPlayingNationalRadar={ setIsPlayingNationalRadar }/> }
                { showConstructionPins &&  <ConstructionPins/>}
                {(selected.includes('opacity')) && <OpacityService/> }
                {(parameters?.defineCustomPin) && <CustomPin customPin={ selected.includes('custom-pin') } setCustomPin={ handleIconClick }/> }
                {(selected.includes('fullscreen')) && <FullScreen setSelected={setSelected}/> }
            <TooltipControls selected={selected}/>
            {
                (Constants.ENVIRONMENT === 'staging') && <div className={ 'dbz-field' } ref={ inputRef }>
                    <input type="number" value={ dbz } min={ 0 } max={ 255 } onChange={ (e) => setDbz(e.target.value) }/>
                    <button onClick={ changeDbz }>Apply</button>
                </div>
            }

        </>
    );
};

